import { AmazonianInformation } from "lib/models/oui-models";
import { Dispatch, SetStateAction, useState } from "react";

import useInput from "../../../hooks/useInput";

export interface AddressFormFields {
  fullName: string;
  country: string;
  countryISO3: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  citySubdivision1: string;
  postalCode: string;
  countryCode: string;
  phoneNumber: string;
}

export interface useChangeAddressFormResult {
  items: useChangeAddressFormItems;
  actions: useChangeAddressFormActions;
}

export interface useChangeAddressFormItems {
  formValues: AddressFormFields;
  isInvalidPhoneNumber: boolean;
}

export interface useChangeAddressFormActions {
  handleInputChange: (field: keyof AddressFormFields, value: any, flag?: string | undefined) => void;
  setAddressInformation: (info: AmazonianInformation) => void;
  hasRequiredFields: () => boolean;
  setIsInvalidPhoneNumber: Dispatch<SetStateAction<boolean>>;
}

export const useChangeAddressForm = (): useChangeAddressFormResult => {
  const [isInvalidPhoneNumber, setIsInvalidPhoneNumber] = useState<boolean>(false);

  // Fill initial values
  const { formValues, handleInputChange, setFormValuesBulk } = useInput<AddressFormFields>({
    fullName: "",
    country: "",
    countryISO3: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    citySubdivision1: "",
    postalCode: "",
    countryCode: "",
    phoneNumber: "",
  });

  const setAddressInformation = (info: AmazonianInformation) => {
    setFormValuesBulk({
      fullName: `${info.basicInfo.firstName} ${info.basicInfo.lastName}`,
      country: "",
      countryISO3: "",
      addressLine1: "",
      addressLine2: "",
      city: "",
      citySubdivision1: "",
      postalCode: "",
      countryCode: "",
      phoneNumber: "",
    });
  };

  const hasRequiredFields = () =>
    formValues.fullName !== "" &&
    formValues.country !== "" &&
    formValues.addressLine1 !== "" &&
    formValues.citySubdivision1 !== "" &&
    formValues.city !== "" &&
    formValues.postalCode !== "" &&
    formValues.countryCode !== "" &&
    formValues.phoneNumber !== "";

  return {
    items: {
      formValues,
      isInvalidPhoneNumber,
    },
    actions: {
      handleInputChange,
      setAddressInformation,
      hasRequiredFields,
      setIsInvalidPhoneNumber,
    },
  };
};
